/**
 * 与后端 sys_user.super_admin / UserDetail.superAdmin 对齐（0 否 1 是）
 */
export function isSuperAdminUser(userInfo) {
  if (!userInfo || typeof userInfo !== "object") {
    return false;
  }
  const v = userInfo.superAdmin ?? userInfo.super_admin;
  return v === 1 || v === "1" || v === true;
}
